import { borderRadius, boxShadow, transition } from '@app/settings/style-util';
import WithDirection from '@app/settings/withDirection';
import styled from 'styled-components';
import { palette } from 'styled-theme';

const TopbarStyleWrapper = styled.div`
  .ant-layout-header {
    color: #ffffff; /* White text to match sidebar */
    background-color: ${palette('secondary', 0)}; /* Match sidebar background */
    padding: 2px 0; /* 2px top and bottom for 40px content area */
    height: 42px !important; /* Total height 42px */
    line-height: 40px !important; /* Content line height 40px */
  }

  .isomorphicTopbar {
    background-color: ${palette('secondary', 0)}; /* Match sidebar background */
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    z-index: 1000;
    align-items: center;
    left: 46px; /* Start to the right of 46px sidebar */
    width: calc(100% - 46px);

    .header-split {
      height: 40px; /* Content area height */
      line-height: 40px;
    }

    .ant-menu-horizontal {
      line-height: 30px;
      background-color: ${palette(
        'secondary',
        0
      )}; /* Match sidebar background */
      color: #ffffff; /* White text to match sidebar */

      .ant-menu-item {
        color: #ffffff; /* White menu items */

        &:hover {
          color: #ffffff; /* Keep white on hover */
        }
      }
    }

    #topbar-info {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      background: ${palette('secondary', 0)}; /* Match sidebar background */
      color: #ffffff; /* White text to match sidebar */

      .topbar-icon {
        height: 18px;
        width: 18px;
        color: #ffffff; /* White icons to match sidebar */
      }

      .crm-search-input {
        width: 100%;
        max-width: 500px;
        padding: 0px 10px;
      }

      h2 {
        color: #ffffff; /* White company logo text */
      }
    }

    .topbar-left {
      order: 1;
      text-align: left;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;

      .logo {
        h2 {
          color: #ffffff; /* White company logo text */
          margin: 0;
          font-size: 18px;
          font-weight: 500;

          a {
            color: #ffffff; /* White link text */
            text-decoration: none;

            &:hover {
              color: #ffffff; /* Keep white on hover */
            }
          }
        }
      }
    }

    .topbar-center {
      order: 2;
      text-align: center;
      flex-grow: 1;
    }

    .topbar-right {
      order: 3;
      text-align: right;
    }

    .topbarSystemMenu {
      justify-content: flex-end;
    }

    .mobile-menu-trigger,
    .isoRight li.mobile-search-trigger,
    .mobile-search-close {
      display: none;
    }

    /* Mobile: no sidebar, full width, search opens over the topbar from an icon */
    @media all and (max-width: 768px) {
      &.ant-layout-header {
        left: 0;
        width: 100%;
      }
      #topbar-info {
        position: relative;
        padding: 0 8px 0 0;
      }
      .mobile-menu-trigger {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border: 0;
        background: transparent;
        color: #ffffff;
        font-size: 20px;
        cursor: pointer;
      }
      .topbar-left {
        display: flex;
        align-items: center;
        flex: 1 1 0;
        min-width: 0;
        order: 1;

        a {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .topbar-right {
        flex: 0 0 auto;
        order: 2;
      }
      .topbar-center {
        display: none;

        &.search-open {
          display: flex;
          align-items: center;
          position: absolute;
          inset: 0;
          z-index: 2;
          padding: 0 0 0 8px;
          background: ${palette('secondary', 0)};

          .crm-search-input {
            flex: 1;
            max-width: none;
            padding: 0;
          }
        }
      }
      .mobile-search-trigger button,
      .mobile-search-close {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        padding: 0;
        background: transparent;
        color: #ffffff;
        cursor: pointer;
      }
      .isoRight li.mobile-search-trigger {
        display: flex;
      }
      .mobile-search-close {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        font-size: 20px;
      }
      /* Make room for the search icon */
      .isoRight li.resources {
        display: none;
      }
      .isoRight li {
        margin-right: 14px;
      }
    }

    .isoLeft {
      display: flex;
      align-items: center;

      @media only screen and (max-width: 767px) {
        margin: ${(props) =>
          props['data-rtl'] === 'rtl' ? '0 0 0 20px' : '0 20px 0 0'};
      }

      .triggerBtn {
        width: 24px;
        height: 100%;
        display: -webkit-inline-flex;
        display: -ms-inline-flex;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        border: 0;
        outline: 0;
        position: relative;
        cursor: pointer;

        &:before {
          content: '\f20e';
          font-family: 'Ionicons';
          font-size: 26px;
          color: inherit;
          line-height: 0;
          position: absolute;
        }
      }
    }

    .isoRight {
      display: flex;
      align-items: center;

      li {
        margin-left: 0;
        margin-right: 16px;
        cursor: pointer;
        line-height: normal;
        position: relative;
        display: inline-block;

        @media only screen and (max-width: 360px) {
          margin-left: 0;
          margin-right: 8px;
        }

        &:last-child {
          margin: 0;
        }

        i {
          font-size: 24px;
          color: #ffffff; /* White icons to match sidebar */
          line-height: 1;
        }

        .isoIconWrapper {
          position: relative;
          line-height: normal;
          padding-right: 10px;

          span {
            font-size: 12px;
            color: #fff;
            background-color: ${palette('secondary', 1)};
            width: 20px;
            height: 20px;
            display: -webkit-inline-flex;
            display: -ms-inline-flex;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            line-height: 20px;
            position: absolute;
            top: -4px;
            left: ${(props) =>
              props['data-rtl'] === 'rtl' ? 'inherit' : '10px'};
            right: ${(props) =>
              props['data-rtl'] === 'rtl' ? '10px' : 'inherit'};
            ${borderRadius('50%')};
          }
        }

        &.isoMail {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 0)};
            }
          }
        }

        &.isoNotify {
          .isoIconWrapper {
            span {
              background-color: ${palette('primary', 2)};
            }
          }
        }

        &.isoMsg {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 1)};
            }
          }
        }

        &.isoCart {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 2)};
            }
          }
        }

        &.isoUserMenu {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 2)};
            }
          }
        }

        &.isoUser {
          .isoImgWrapper {
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            background-color: ${palette('grayscale', 9)};
            ${borderRadius('50%')};

            img {
              height: 100%;
              object-fit: cover;
            }

            .userActivity {
              width: 10px;
              height: 10px;
              display: block;
              background-color: ${palette('color', 3)};
              position: absolute;
              bottom: 0;
              right: 3px;
              border: 1px solid #ffffff;
              ${borderRadius('50%')};
            }
          }
        }
      }
    }

    .ant-menu-item {
      padding: 0 16px;
    }
  }

  .isoUserDropdown {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoUserDropdownContent {
          padding: 7px 0;
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #ffffff;
          width: 220px;
          min-width: 160px;
          flex-shrink: 0;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          .isoDropdownLink {
            font-size: 13px;
            color: ${palette('text', 1)};
            line-height: 1.1;
            padding: 7px 15px;
            background-color: transparent;
            text-decoration: none;
            display: flex;
            justify-content: flex-start;
            ${transition()};

            &:hover {
              background-color: ${palette('secondary', 6)};
            }
          }
        }
      }
    }
  }

  // Dropdown
  .ant-popover {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoDropdownContent {
          display: flex;
          flex-direction: column;
          position: absolute;
          top: 0;
          right: 0;
          background-color: #ffffff;
          width: 360px;
          min-width: 160px;
          flex-shrink: 0;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          @media only screen and (max-width: 767px) {
            width: 310px;
          }

          .isoDropdownHeader {
            border-bottom: 1px solid #f1f1f1;
            margin-bottom: 0px;
            padding: 15px 30px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            h3 {
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-align: center;
              text-transform: uppercase;
              margin: 0;
            }
          }

          .isoDropdownBody {
            width: 100%;
            height: 300px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;
            background-color: ${palette('grayscale', 6)};

            .isoDropdownListItem {
              padding: 15px 30px;
              flex-shrink: 0;
              text-decoration: none;
              display: flex;
              flex-direction: column;
              text-decoration: none;
              width: 100%;
              ${transition()};

              &:hover {
                background-color: ${palette('grayscale', 3)};
              }

              .isoListHead {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
              }

              h5 {
                font-size: 13px;
                font-weight: 500;
                color: ${palette('text', 0)};
                margin-top: 0;
              }

              p {
                font-size: 12px;
                font-weight: 400;
                color: ${palette('text', 2)};
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .isoDate {
                font-size: 11px;
                color: ${palette('grayscale', 1)};
                flex-shrink: 0;
              }
            }
          }

          .isoViewAllBtn {
            font-size: 13px;
            font-weight: 500;
            color: ${palette('text', 2)};
            padding: 10px 15px 20px;
            display: flex;
            text-decoration: none;
            align-items: center;
            justify-content: center;
            text-align: center;
            ${transition()};

            &:hover {
              color: ${palette('primary', 0)};
            }
          }

          .isoDropdownFooterLinks {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 30px 20px;

            a {
              font-size: 13px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-decoration: none;
              padding: 10px 20px;
              line-height: 1;
              border: 1px solid ${palette('border', 1)};
              display: flex;
              align-items: center;
              justify-content: center;
              ${transition()};

              &:hover {
                background-color: ${palette('primary', 0)};
                border-color: ${palette('primary', 0)};
                color: #ffffff;
              }
            }

            h3 {
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              line-height: 1.3;
            }
          }

          &.withImg {
            .isoDropdownListItem {
              display: flex;
              flex-direction: row;

              .isoImgWrapper {
                width: 35px;
                height: 35px;
                overflow: hidden;
                margin-right: 15px;
                display: -webkit-inline-flex;
                display: -ms-inline-flex;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                background-color: ${palette('grayscale', 9)};
                ${borderRadius('50%')};

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .isoListContent {
                width: 100%;
                display: flex;
                flex-direction: column;

                .isoListHead {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 10px;
                }

                h5 {
                  margin-bottom: 0;
                  padding-right: 15px;
                }

                .isoDate {
                  font-size: 11px;
                  color: ${palette('grayscale', 1)};
                  flex-shrink: 0;
                }

                p {
                  white-space: normal;
                  line-height: 1.5;
                }
              }
            }
          }
        }
      }
    }

    &.topbarMail {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 519px) {
              right: -170px;
            }
          }
        }
      }
    }

    &.topbarMessage {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 500px) {
              right: -69px;
            }
          }
        }
      }
    }

    &.topbarNotification {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 500px) {
              right: -120px;
            }
          }
        }
      }
    }

    &.topbarAddtoCart {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (max-width: 465px) {
              right: -55px;
            }

            .isoDropdownHeader {
              margin-bottom: 0;
            }

            .isoDropdownBody {
              background-color: ${palette('grayscale', 6)};
            }
          }
        }
      }
    }
  }
`;

export const TopbarWrapper = WithDirection(TopbarStyleWrapper);
